import { computed } from 'vue'
import { useStore } from 'vuex'
import {
  type RouteUpSellingDetail,
  NON_OWNER_UPSELLING_MESSAGE,
} from '@/utils/upselling'
import { useRouter } from 'vue-router'
import { DETAILS_OVERRIDES } from '@/utils/upselling'
import { ROUTE_UPSELLING_DETAILS } from '@/utils/upselling'

type Options = {
  resolveDetail?: () => RouteUpSellingDetail | undefined
}

export const useUpselling = ({
  resolveDetail
}: Options = {}) => {
  const store = useStore()
  const router = useRouter()

  /* Currently used to skip showing the unsaved form dialog since we have a use case where user is redirected to atten */
  const isRouteAccessible = computed(() => {
    const matchedRouteDetail = ROUTE_UPSELLING_DETAILS.find(route => route?.routeName?.includes(router.currentRoute.value.name as string))

    return !matchedRouteDetail || store.state.features.includes(matchedRouteDetail?.feature)
  })

  const infoBannerDetails = computed<RouteUpSellingDetail>(() => {
    const base = resolveDetail?.() || {
      feature: '',
      title: 'Unlock Premium Features!',
      detailsList: ['Upgrade to access this feature and more!'],
      additionalDetails: 'This feature is available with the <i>Premium Plan.</i>',
    }

    let details: RouteUpSellingDetail = {
      ...base,
      detailsList: base.detailsList ? [...base.detailsList] : base.detailsList,
      routeName: base.routeName ? [...base.routeName] : base.routeName,
      redirectTo: base.redirectTo ? [...base.redirectTo] : base.redirectTo,
      primaryCta: {
        text: 'Upgrade Now',
        action: () => router.push({ name: 'billing-subscription' }),
      }
    }

    /* Override for non-account owners */
    if (!store.getters.isAccountOwner) {
      details.additionalDetails = NON_OWNER_UPSELLING_MESSAGE
      // Non-owners should not see the upgrade button as they cannot upgrade themselves
      details.primaryCta = undefined
    } 

    /* Overrides for specific countries or distributors */
    if (store.getters.isByxbiOrg) {
      details = {
        ...details,
        ...DETAILS_OVERRIDES.byxbiOrg,
      }
    }

    return details
  })

  return {
    isRouteAccessible,
    infoBannerDetails
  }
}